import React from 'react';
import { Button, Form, Input, Space, Typography } from 'antd';

type ThirdStepProps = {
  goToNext: () => void;
  goToPrevious: () => void;
  setThirdStepData: (data: ThirdStepFormInputs) => void;
  thirdStepData: ThirdStepFormInputs | null;
};

export type ThirdStepFormInputs = {
  minCashBackAmount: number,
  maxCashBackAmount: number
};

const ThirdStep: React.FC<ThirdStepProps> = ({ goToNext, goToPrevious, setThirdStepData, thirdStepData }) => {
  const [form] = Form.useForm();

  const onSubmit = (data: ThirdStepFormInputs) => {
    setThirdStepData(data);
    goToNext();
  }

  return (
    <Form<ThirdStepFormInputs>
      layout="horizontal"
      onFinish={onSubmit}
      initialValues={thirdStepData || undefined}
      form={form}
      style={{ width: 'max-content', maxWidth: '100%', margin: 'auto' }}
    >
      <Typography.Title level={2}>Retiros</Typography.Title>
      <Form.Item<ThirdStepFormInputs>
        style={{ textAlign: 'center' }}
        name="minCashBackAmount"
        label={'Minimo'}
        rules={[{min: 0, required: true, message: 'Por favor, ingresa un monto.' }]}
      >
        <Input type={"number"} />
      </Form.Item>
      <Form.Item<ThirdStepFormInputs>
        name="maxCashBackAmount"
        label={'Maximo'}
        rules={[{min: 0, required: true, message: 'Por favor, ingresa un monto.' }]}
      >
        <Input type={"number"} />
      </Form.Item>
      <Space>
        <Button onClick={goToPrevious}>Anterior</Button>
        <Button htmlType="submit" type="primary">
          Siguiente
        </Button>
      </Space>
    </Form>
  )
}

export default ThirdStep;